import { render } from "./GalleryList.vue?vue&type=template&id=707e453e&scoped=true"
import script from "./GalleryList.vue?vue&type=script&lang=js"
export * from "./GalleryList.vue?vue&type=script&lang=js"

import "./GalleryList.vue?vue&type=style&index=0&id=707e453e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-707e453e"]])

export default __exports__